import React, { Component } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import config from "../../../../config";
import axios from "axios";
import NoteItem from "./NoteItem";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";

import errorFunctions from "../../../../store/errorFunctions";

Modal.setAppElement("body");
export default class CommercialNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditNote: false,
      showAddNote: false,
      showAddMedia: false,
      showNotes: true,
      editedNoteId: "",
      parentId: "",
      addedNote: "",
      editedNote: "",
      mediaTypeWarning: "",
      showDueDateChangeModal: false,
      commercialNotes: [],
    };
  }
  componentDidMount() {
    Modal.setAppElement("body");
    this.retriveCommercialNotes();
  }
  retriveCommercialNotes() {
    this.props
      .protectedFetch(config.backendServer + `ticket/${this.props.details?.id}/commercial-note/`, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        console.log(res);
        this.setState({
          isLoading: false,
          commercialNotes: res || [],
        });
        this.props.setDefaultTab();
      });
  }

  handleSubmitNote = () => {
    this.setState({
      disableBtnNote: true,
    });
    let formData = new FormData();
    if (this.state.parentId) formData.append("parent", this.state.parentId);
    formData.append("note", this.state.addedNote);
    this.addNote(formData);
  };

  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };

  handleAddNote = () => {};

  addNote(formData) {
    const token = this.props.userInfo.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };

    const url = `${config.backendServer}ticket/${this.props.details?.id}/commercial-note/`;
    axios
      .put(url, formData, options)
      .then(() => {
        this.setState({
          addedNote: "",
          parentId: "",
          editedNoteId: "",
          editedNote: null,
          showAddNote: false,
          disableBtnNote: false,
          isLoading: false,
        });
        this.retriveCommercialNotes();
        this.props.setDefaultTab();
        this.props.retrieveWarranty();
      })
      .catch((error) => {
        // Handle the error or show an error message
        if (error)
          alert(error?.response?.data?.non_field_errors?.[0] || error?.response?.data?.serial_number?.[0] || "Something went wrong.. try later");
        this.setState({ isLoading: false });
      });
  }

  render() {
    // const details = this.props.details || {};

    let that = this;

    return (
      <div>
        <div className="d-flex flex-row">
          <div className="p-2 ">
            {" "}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                this.setState({
                  showAddNote: true,
                  editedNoteId: "",
                  editedNote: null,
                });
              }}
            >
              Add Communication
            </button>
          </div>
        </div>
        <div className={"activity-wrapper"}>
          <ul style={{ padding: "0px" }}>
            {this.state.commercialNotes &&
              this.state.commercialNotes
                ?.sort((a, b) => {
                  return moment(b.created) - moment(a.created);
                })
                .map(function (item, i) {
                  return (
                    <NoteItem
                      userInfo={that.props?.userInfo}
                      note={item}
                      key={i}
                      handleEditNote={(formData) => that.addNote(formData)}
                      replyNote={(parentId) => that.setState({ parentId, showAddNote: true, editedNoteId: "", editedNote: null })}
                      ticketId={that.props.details?.id}
                      retrieveWarranty={() => {
                        that.props.retrieveWarranty();
                        that.props.setDefaultTab();
                      }}
                      retrieveCommunication={() => {
                        that.retriveCommercialNotes();
                        that.props.setDefaultTab();
                      }}
                      setDefaultTab={that.props.setDefaultTab}
                      protectedFetch={that.props.protectedFetch}
                    />
                  );
                })}
          </ul>
        </div>
        <Modal isOpen={this.state.showAddNote} contentLabel={"Add Communication"} className={"input-modal w-25 h-50 "}>
          <div className="card  h-100">
            <button onClick={() => this.setState({ showAddNote: false })} className={"confirm-modal-close"}>
              <MdClose />
            </button>
            <div className={"card-header"}>{`${this.state.editedNote ? "Edit" : "Add"} Communication`}</div>
            <div className="card-body overflow-auto">
              <ReactQuill
                height={"100%"}
                value={this.state.addedNote || this.state.editedNote || ""}
                onChange={(val) => this.setState({ addedNote: val })}
                id={"editedNote"}
              />
            </div>
            <div className="card-footer">
              <button disabled={this.state.disableBtnNote} type="button" className={"btn btn-outline-primary mr-3"} onClick={this.handleSubmitNote}>
                Save
              </button>
              <button type={"button"} className={"btn btn-outline-secondary"} onClick={() => this.setState({ showAddNote: false, addedNote: "" })}>
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
